import { useChatContext } from './ChatContext';

const useMessages = () => {
    const {
        messages,
        // setMessages,
        message,
        setMessage,
    } = useChatContext();
    return {
        messages,
        // setMessages,
        message,
        setMessage,
    };
};

export default useMessages;
